import { LinkTag } from '@qaroni-core/types/metadata/link-tag';
import { BucketS3Env } from '@qaroni-core/config/bucket-s3/bucket-s3.config';

export const LINKTAGSARRAY: LinkTag[] = [
  {
    rel: 'shortcut icon',
    href: `${BucketS3Env.baseUrl}/favicon/favicon.ico`,
    type: 'image/x-icon',
  },
  {
    rel: 'apple-touch-icon',
    href: `${BucketS3Env.baseUrl}/favicon/apple-touch-icon-57x57.png`,
    sizes: '57x57',
  },
  {
    rel: 'apple-touch-icon',
    href: `${BucketS3Env.baseUrl}/favicon/apple-touch-icon-60x60.png`,
    sizes: '60x60',
  },
  {
    rel: 'apple-touch-icon',
    href: `${BucketS3Env.baseUrl}/favicon/apple-touch-icon-72x72.png`,
    sizes: '72x72',
  },
  {
    rel: 'apple-touch-icon',
    href: `${BucketS3Env.baseUrl}/favicon/apple-touch-icon-76x76.png`,
    sizes: '76x76',
  },
  {
    rel: 'apple-touch-icon',
    href: `${BucketS3Env.baseUrl}/favicon/apple-touch-icon-114x114.png`,
    sizes: '114x114',
  },
  {
    rel: 'apple-touch-icon',
    href: `${BucketS3Env.baseUrl}/favicon/apple-touch-icon-120x120.png`,
    sizes: '120x120',
  },
  {
    rel: 'apple-touch-icon',
    href: `${BucketS3Env.baseUrl}/favicon/apple-touch-icon-144x144.png`,
    sizes: '144x144',
  },
  {
    rel: 'apple-touch-icon',
    href: `${BucketS3Env.baseUrl}/favicon/apple-touch-icon-152x152.png`,
    sizes: '152x152',
  },
  {
    rel: 'apple-touch-icon',
    href: `${BucketS3Env.baseUrl}/favicon/apple-touch-icon-180x180.png`,
    sizes: '180x180',
  },
  {
    rel: 'icon',
    href: `${BucketS3Env.baseUrl}/favicon/favicon-16x16.png`,
    type: 'image/png',
    sizes: '16x16',
  },
  {
    rel: 'icon',
    href: `${BucketS3Env.baseUrl}/favicon/favicon-32x32.png`,
    type: 'image/png',
    sizes: '32x32',
  },
  {
    rel: 'icon',
    href: `${BucketS3Env.baseUrl}/favicon/favicon-96x96.png`,
    type: 'image/png',
    sizes: '96x96',
  },
  {
    rel: 'icon',
    href: `${BucketS3Env.baseUrl}/favicon/android-chrome-192x192.png`,
    type: 'image/png',
    sizes: '192x192',
  },
  {
    rel: 'stylesheet',
    href: `https://fonts.googleapis.com/icon?family=Material+Icons`,
  },
];
